import { useIntl } from 'react-intl';
import type { PathRecord } from '../../bff-api/products/model/PathRecord';
import type { BreadcrumbsItemsList } from './types';

export const useBreadcrumbs = (categories?: PathRecord[]): BreadcrumbsItemsList[] => {
    const intl = useIntl();

    if (!categories) {
        return [];
    }

    const list = [
        {
            label: intl.formatMessage({
                id: 'breadcrumbs.home',
                defaultMessage: 'Home',
            }),
            href: '/',
        },
        ...categories.map(({ name, c_href }) => ({ label: name!, href: c_href! })),
    ];

    return list;
};
